export const moveArrayItem = (array, from, to) => {
  const result = array;
  const element = result[from];
  result.splice(from, 1);
  result.splice(to, 0, element);

  return result;
};
